import { Field } from 'react-final-form';
import Radio from 'components/other/Radio';
import Icon from 'components/other/Icons';

import styles from './TestForm.module.scss';

const SubscriptionRightsKnowledgeField = field => (
  <div className={styles.FieldContainer} tabIndex="0">
    <p>Kunnskap om tegningsretter:</p>
    <Field name="subscriptionRightsKnowledge" type="radio" value="low">
      {({ input }) => (
        <label htmlFor="subscriptionRightsKnowledge_low">
          <Radio
            id="subscriptionRightsKnowledge_low"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Ingen
        </label>
      )}
    </Field>
    <Field name="subscriptionRightsKnowledge" type="radio" value="medium">
      {({ input }) => (
        <label htmlFor="subscriptionRightsKnowledge_medium">
          <Radio
            id="subscriptionRightsKnowledge_medium"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Middels
        </label>
      )}
    </Field>
    <Field name="subscriptionRightsKnowledge" type="radio" value="high">
      {({ input }) => (
        <label htmlFor="subscriptionRightsKnowledge_high">
          <Radio
            id="subscriptionRightsKnowledge_high"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Høy
        </label>
      )}
    </Field>
    {field.meta.error && field.meta.touched && (
      <div className={styles.errorContainer}>
        <Icon icon="exclamation-triangle" />
        <span>{field.meta.error}</span>
      </div>
    )}
  </div>
);

export default SubscriptionRightsKnowledgeField;
